export default __webpack_public_path__ + "static/media/logo-equal.a42fac71.png";